export interface IRangeMeta {
  min: number;
  max: number;
  multiply: number;
  step: number;
  sub_label?: string;
  unit?: NumberUnitType;
  input_prefix?: string;
}

export enum FilterType {
  DATE_RANGE = 'date_range',
  SELECT = 'select',
  MULTI_SELECT = 'multi_select',
  BOOLEAN = 'boolean',
  NUMBER_RANGE = 'number_range',
  LOCATION = 'location',
  GROUPED_MULTI_SELECT = 'grouped_multi_select', // e.g. combined location in cred builder or Education in RRA/Enterprise PeopleFinder
  GROUPED_NUMBER_RANGE = 'grouped_number_range', // e.g. Candid section in PeopleFinder
};

export enum FilterToggleState {
  MUST_HAVE = 'Must Have',
  NICE_TO_HAVE = 'Nice to have',
}

export interface IMainGroup {
  id: string;
  title: string;
  icon: string;
  identifier: string;
  sidebar_attributes: string[];
  show_group?: boolean;
  empty_message?: string;
  sidebar_group_sectionId_map?: { [key: string]: string };
  default_section_id?: string;
  is_grouped_dd?: boolean;
  has_boolean_search?: boolean;
  placeholder?: string;
  addToKeyword?: boolean;
}

export enum NumberUnitType {
  number = 'number',
  money = 'money',
  year = 'year',
  year_no_multiplier = 'year_no_multiplier', // no multiplier applied
}

export interface IUnitDetails {
  min: number;
  max: number;
  multiply: number;
  sub_label?: string;
}

export interface IUICategory {
  id: string; // unique id for the category
  ui_cat_wl?: string[]; // white listed categories
  toggle_state: FilterToggleState; // default toggle state for the category
  title: string; // title of the category
  section_id: string; // section id for the category ideally same as id
  enabled: boolean; // enabled state of the category
  kw_prefix?: string; // keyword prefix for the category to be used as prefix for category keywords
  icon: string; // icon for the category preferably from google font icons
  disable_toggle_state?: boolean; // disable toggle state i.e not showing option to toggle
  must_have_action?: boolean; // if true, then must have action button is shown,
  disable_option_search?: boolean;
  filter_type: FilterType;
  unit?: NumberUnitType; //
  search_field?: string; // search field for the category
  enableBrowseAll?: boolean;
  multi_input_by_comma?: boolean; // if true, then multi input by comma is enabled
  rangeMeta?: IRangeMeta;
}